import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Button, IconButton, withStyles } from "@material-ui/core";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import { resizeImageByPercentage } from "utils/Utils";
import { Slider } from "@material-ui/core";
import brandTheme from "brandTheme/Theme";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { saveAadharTransaction } from "store/reducers/LoanApplication/LoanApplicationSlice";
import { useDispatch, useSelector } from "react-redux";
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import ToastModal from "views/components/ToastModal";

const LiveCameraComponent = ({
  classes,
  label,
  loanApplicationId,
  loanApplicationNumber,
  customerImage,
  faceLineNessVendor,
  imageIcon,
  newOrnamentsToggle,
  mobileNumber
}) => {
  const [callInProgress, setCallInProgress] = useState(false);
  const dispatch = useDispatch();
  const { authToken } = useSelector((state) => state.login.authData);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const onClickCamera = async () => {
     setCallInProgress(true)
        //ADMIN_LOANACCOUNTNUMBER;
        const res = await apiHandler({
          url: endpoint.FACE_LIVENESS_INIT,
          method: "POST",
          authToken: authToken,
          data: {
            sourceId:loanApplicationId,
	          callbackurl: window.location.origin + "/selfie-liveness",
            vendor:faceLineNessVendor,
          }
        });
        setCallInProgress(false)
        if(res?.data?.error_code){
          toastUpdate("Error",res?.data?.user_description,true);
        } else{
        if (res?.data?.redirectUrl) {
          dispatch(
            saveAadharTransaction({
              loanApplicationId,
              loanApplicationNumber,
              newOrnamentsToggle,
              mobileNumber,
            })
          );
          const key = `selfie-${loanApplicationId}`;
          sessionStorage.removeItem(key);
          window.location.href = res?.data?.redirectUrl;
        } 
      }
  };

  return (
    <div>
      <GridContainer style={{ marginTop: 0 }}>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <GridItem xs={12} sm={12} md={12} lg={12}>    
            <GridContainer  onClick={onClickCamera} role="button">
                <GridItem
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    width: '300px',
                    height: '300px',
                    border: '1px solid #ccc',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    overflow: 'hidden',
                    position: 'relative',
                  }}
                >
                  {customerImage ? (
                     <div
                    className={classes.imageWrapper}
                  >
                    <img
                       src={customerImage}
                      alt="Captured"
                      style={{
                        width: '300px',
                        height: '300px',
                        objectFit: 'cover',
                        transition: 'opacity 0.3s ease',
                      }}
                    />
                    <div className={classes.overlay}>
                      Edit
                    </div>
                  </div>
                  ) : (
                  <img
                      src={imageIcon}
                      alt="Upload Placeholder"
                      style={{
                        width: '86%',
                        height: '81%',
                        objectFit: 'cover',
                      }}
                    />
                  )}
                </GridItem>
            </GridContainer>
          </GridItem>
        </GridItem>
      </GridContainer>
      {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
        {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </div>
  );
};

LiveCameraComponent.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  editable: PropTypes.object,
  closeModal: PropTypes.func,
};

export default LiveCameraComponent;
